var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTargetIcon = function SvgTargetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    clipPath: "url(#target-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4M8 2.667V1.333M2.666 8H1.333M8 13.333v1.334M13.333 8h1.333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "target-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgTargetIcon;